var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scoreboard-list-report',{attrs:{"report":_vm.report,"study":_vm.study,"index":_vm.index}})
}
var staticRenderFns = []

export { render, staticRenderFns }